import React from 'react'
import {KTIcon} from '../../_metronic/helpers'
import {useThemeMode} from '../../_metronic/partials'

interface IProps {
  type?: 'button' | 'submit' | 'reset'
  onClick: (...args: any[]) => void
  className?: string
  iconName?: string
  iconClassName?: string
  disabled?: boolean
  loading?: boolean
  tooltip?: string
  children: React.ReactNode
}

const LightOutlineButton = ({
  onClick,
  type = 'button',
  className = '',
  iconName,
  iconClassName = '',
  disabled = false,
  loading = false,
  tooltip = '',
  children,
}: IProps) => {
  const {mode} = useThemeMode()
  return (
    <button
      type={type}
      onClick={loading ? undefined : onClick}
      disabled={disabled || loading}
      className={`btn btn-sm bg-${
        mode === 'dark' ? 'secondary' : 'white'
      } btn-outline border-muted text-muted btn-active-light-secondary ${className} d-flex align-items-center`}
      data-bs-toggle='tooltip'
      title={tooltip || ''}
    >
      {iconName && (
        <KTIcon iconName={iconName} className={`fs-3 text-secondary ${iconClassName}`} />
      )}
      {children}
    </button>
  )
}

export {LightOutlineButton}
